import React, { Component } from 'react';
import { Route, /*Redirect,*/ Switch } from 'react-router-dom';

import AuthContext from './contexts/AuthContext';

import * as Urls from './constants/appUrls';
import Layout from './hoc/Layout';
import Login from './containers/Auth/Login';
import SignUp from './containers/Auth/SignUp';
import Logout from './containers/Auth/Logout';
import Home from './containers/Home/Home';
import Chat from './containers/Chat/Chat';
import Account from './containers/Account/Account';
import VideoChat from './containers/VideoChat/VideoChat';

let logoutTimer;

class App extends Component {

    state = {
        token: null,
        userId: null,
        firstName: null,
        lastName: null,
        tokenExpirationDate: null,
    }

    login = (token, userId, firstName, lastName, expirationDate) => {
        const tokenExpirationDate = new Date(expirationDate) || new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
        localStorage.setItem(
            'userData',
            JSON.stringify({
                token: token,
                userId: userId,
                firstName: firstName,
                lastName: lastName,
                expiration: tokenExpirationDate.toISOString()
            })
        );
        this.setState({
            token: token,
            userId: userId,
            firstName: firstName,
            lastName: lastName,
            tokenExpirationDate: tokenExpirationDate
        })
    }

    logout = () => {
        this.setState({
            token: null,
            userId: null,
            firstName: null,
            lastName: null,
            tokenExpirationDate: null,
        })
        localStorage.removeItem('userData');
    }

    autoLogin = async () => {
        const storedData = JSON.parse(localStorage.getItem('userData'));
        if (
            storedData &&
            storedData.token &&
            new Date(storedData.expiration) > new Date()
        ) {
            this.login(storedData.token, storedData.userId, storedData.firstName, storedData.lastName, new Date(storedData.expiration));
        }
    }

    autoLogout = () => {
        if (this.state.token && this.state.tokenExpirationDate) {
            const remainingTime = this.state.tokenExpirationDate.getTime() - new Date().getTime();
            logoutTimer = setTimeout(this.logout, remainingTime);
        } else {
            clearTimeout(logoutTimer);
        }
    }

    componentDidUpdate() {
        this.autoLogout();
    }

    componentDidMount() {
        this.autoLogin();
    }

    render() {

        let routes = (
            <Switch>
                <Route path={Urls.loginUrl} exact component={Login} />
                <Route path={Urls.signUpUrl} exact component={SignUp} />
                <Route path={Urls.homeUrl} exact component={Home} />
                {/* <Redirect to={Urls.homeUrl} /> */}
            </Switch>
        );

        if (this.state.token != null) {
            routes = (
                <Switch>
                    <Route path={Urls.logoutUrl} exact component={Logout} />
                    <Route path={Urls.homeUrl} exact component={Chat} />
                    <Route path={Urls.myProfileUrl} component={Account} />
                    <Route path={Urls.videoChatUrl} component={VideoChat} />
                    {/* <Redirect to={Urls.homeUrl} /> */}
                </Switch>
            );
        }

        return (
            <AuthContext.Provider value={{
                isLoggedIn: this.state.token != null,
                token: this.state.token,
                userId: this.state.userId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                login: this.login,
                logout: this.logout
            }} >

                <Layout>
                    {routes}
                </Layout>

            </AuthContext.Provider>
        );
    }

}

export default App;